import React, { useState, useEffect } from 'react';

const PhoneButton = () => {
  const [phoneNumber, setPhoneNumber] = useState('905321234567'); // Varsayılan telefon numarası

  useEffect(() => {
    fetchContactInfos();
  }, []);

  const fetchContactInfos = async () => {
    try {
      const response = await fetch('http://localhost/api/pages.php?type=contact', {
        credentials: 'include',
      });
      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];
        const phoneInfo = Array.isArray(data) ? data.find(info => info.type === 'phone') : null;
        if (phoneInfo && phoneInfo.content) {
          // Telefon numarasından özel karakterleri temizle
          const cleanedPhone = phoneInfo.content.replace(/[^\d+]/g, '');
          setPhoneNumber(cleanedPhone);
        }
      }
    } catch (error) {
      console.error('Error fetching contact infos:', error);
    }
  };
  
  const handleClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="fixed bottom-24 right-6 z-50 flex items-center group">
      {/* Hover Text */}
      <span className="mr-3 px-4 py-2 bg-[#007AFF] text-white text-sm font-semibold rounded-full shadow-lg opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap pointer-events-none">
        Bizi arayın
      </span>
      
      {/* Button */}
      <button
        onClick={handleClick}
        className="w-14 h-14 bg-[#007AFF] hover:bg-[#0051D5] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 relative"
        aria-label="Telefon ile iletişime geç"
        title="Bizi arayın"
      >
        {/* Phone Icon SVG */}
        <svg 
          viewBox="0 0 24 24" 
          className="w-7 h-7 fill-white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
        
        {/* Pulse animasyonu için */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#007AFF] opacity-75 animate-ping"></span>
      </button>
    </div>
  );
};

export default PhoneButton;

